/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */
import { Injectable } from '@angular/core';

/**
 * This service is used to get the current window location.
 * The idea is to make it easier to mock the window location in tests.
 */

@Injectable({
	providedIn: 'root',
})
export class WindowLocationService {
	public redirect(url: string): void {
		window.location.assign(url);
	}

	public get href(): string {
		return window.location.href;
	}

	public get hostname(): string {
		return window.location.hostname;
	}

	public get pathname(): string {
		return window.location.pathname;
	}

	public get protocol(): string {
		return window.location.protocol;
	}

	public get port(): string {
		return window.location.port;
	}

	public get search(): string {
		return window.location.search;
	}

	public get hash(): string {
		return window.location.hash;
	}
}
